import React from 'react';
import { MathCCAClass3to52026 } from '../views';

const MathClubPage = () => {
  return <MathCCAClass3to52026/>;
};

export default MathClubPage;